import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=4ecb38f9&lang=pug&"
import script from "./AdminOrders.vue?vue&type=script&lang=js&"
export * from "./AdminOrders.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports